// Workaround for a header layout-shift patch in global.js native to the theme, that broke smooth scrolling.
// Prevents same-page anchor links from getting stuck while scrolling.
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      const target = document.querySelector(this.getAttribute("href"));

      window.scrollBy({
        top: 5,
        left: 0,
        behavior: "auto",
      });

      setTimeout(() => {
        target.scrollIntoView({
          behavior: "smooth",
        });
      }, 20);
    });
  });
});
